import { CalendarClock, CircleCheck, CircleHelp, CircleX } from 'lucide-react'

import {
  StatusBadge,
  type StatusTone,
} from '../../../ui/StatusBadge/StatusBadge'
import type { AppointmentItem } from '../appointments-model'

export function AppointmentStatusBadge({
  appointment,
}: {
  appointment: AppointmentItem
}) {
  const Icon =
    appointment.status === 'scheduled'
      ? CalendarClock
      : appointment.status === 'confirmed'
        ? CircleCheck
        : appointment.status === 'cancelled'
          ? CircleX
          : CircleHelp
  const tone: StatusTone =
    appointment.status === 'scheduled'
      ? 'info'
      : appointment.status === 'confirmed'
        ? 'success'
        : appointment.status === 'cancelled'
          ? 'danger'
          : 'neutral'
  return (
    <StatusBadge tone={tone} icon={<Icon size={12} aria-hidden="true" />}>
      {appointment.statusLabel}
    </StatusBadge>
  )
}
